<div id="login" class="float-panel lg-form-container" fxLayout="column" *ngIf="initialized">

    <div id="login-form-wrapper" class="lg-form-wrapper" fxLayout="column" fxLayoutAlign="center center" *ngcIfOnDom [@animate]="{value:'*',params:{duration:'300ms',y:'100px'}}">

        <div id="login-form" class="lg-form" *ngcIfOnDom fxLayout="column" fxLayoutAlign="center center">

            <div id="login-form-block">
                <div class="logo" alt="logo"></div>

                <button mat-raised-button color="accent"
                        id="log-in-as-district-button"
                        class="submit-button"
                        aria-label="Sign in as District Admin"
                        (click)="loginWithSchoolPassport()">
                    Sign in as District Admin
                </button>

                <button mat-raised-button color="accent"
                        id="log-in-as-vendor-button"
                        class="submit-button"
                        aria-label="Sign in as Vendor"
                        (click)="internalLogin()">
                    Sign in as Vendor
                </button>
            </div>
        </div>
    </div>

    <ngc-footer-page *ngcIfOnDom [textColor]="'white'"></ngc-footer-page>
</div>
